

export class ApiResponse {

	public success: boolean;

	public result: any;

	public message: string;

	public errors: Array<any>;

	constructor(obj?: any) {
		this.success = obj && obj.success || null;
		this.result = obj && obj.result || null;
		this.message = obj && obj.message || null;
		this.errors = obj && obj.errors || null;
	}
}
